import React from 'react';

import useFilesInDocumentStore from '@/components/controls/DropScan/useFilesInDocument.store';
import { USE_MY_MONEY_UPLOAD_STORE_KEY } from '@/modules/UseMyMoney/UseMyMoney.types';

import DocumentCardWithFiles from './DocumentCardWithFiles';
import EmptyDocumentCard from './EmptyDocumentCard';

interface Props {
  onOpenPreview?: () => void;
  onUploadFile?: () => void;
}

const DocumentUploadCard: React.FC<Props> = ({ onOpenPreview, onUploadFile }) => {
  const { values: { files } } = useFilesInDocumentStore(USE_MY_MONEY_UPLOAD_STORE_KEY);

  const hasFiles = files && files.length > 0;

  if (hasFiles) {
    return (
      <DocumentCardWithFiles
        files={files}
        onOpenPreview={onOpenPreview}
        onOpenUpload={onUploadFile}
      />
    );
  }

  return (
    <EmptyDocumentCard onUploadFile={onUploadFile} />
  );
};

export default DocumentUploadCard;
